import { Loader } from '@grafikr/components';

export default Loader(({ node }, load) => {
  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          load();
        }
      });
    },
    { rootMargin: node.dataset.rootMargin },
  );

  observer.observe(node);
});
